import { createFileRoute } from '@tanstack/react-router'
import { SuratTemplateManager } from '../../../../components/SuratTemplateManager'
import { TemplateEditorPage } from '../../../../components/surat-template/editor/TemplateEditorPage'
import { useListScrollRestore } from '../../../../hooks/useListScrollRestore'

// K-2: lihat alasan lengkap di routes/desa/$slug/dashboard/template-surat.tsx — shell platform
// menghitung activeTab dengan cara yang sama (routes/platform/desa/$desaId/route.tsx:19-20),
// jadi editor tetap dibuka lewat search param, bukan sub-route (R10).
export const Route = createFileRoute('/platform/desa/$desaId/template-surat')({
  component: TemplateSuratPlatformRoute,
  validateSearch: (search: Record<string, unknown>): { edit?: string } => ({
    edit: typeof search.edit === 'string' ? search.edit : undefined,
  }),
})

function TemplateSuratPlatformRoute() {
  const { desaId } = Route.useParams()
  const { edit } = Route.useSearch()
  const navigate = Route.useNavigate()
  // R11: lihat alasan di routes/desa/$slug/dashboard/template-surat.tsx — shell platform
  // berpindah daftar <-> editor dengan cara yang sama, jadi diperlakukan sama pula.
  useListScrollRestore(!edit)

  if (!edit) return <SuratTemplateManager desaId={desaId} />

  return (
    <TemplateEditorPage
      // R1: remount saat pindah ?edit=A → ?edit=B, agar state form template lama tidak bocor.
      key={edit}
      desaId={desaId}
      editId={edit}
      onBack={() => navigate({ search: { edit: undefined } })}
    />
  )
}
